<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Currency Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doSelect">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
              <v-data-table
                :headers="headers"
                :items="items"
                :loading="loading"
                :custom-filter="customSearch"
                :no-data-text="noDataText"
                item-key="key"
                show-select
                v-bind:search="search"
                v-model="selected"
                @input="enterSelect"
                @toggle-select-all="enterSelectAll(pagination, items, selected)"
              >
              </v-data-table>
              <div v-if="checkedItems.length === 0" class="small font-weight-light grey--text">Note: Default is "All" if no item is selected.</div>
              <v-textarea v-if="checkedItems.length > 0" label="Selected Items" v-model="checkedItems" rows="1" readonly></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" dark class="mb-2" @click="doSelect('All', 'curr')">
                Select All
                <v-icon right>mdi-check-all</v-icon>
              </v-btn>
              <v-btn color="info" dark class="mb-2" @click.prevent="doReset">
                Reset
                <v-icon dark right>mdi-refresh</v-icon></v-btn
              >
              <v-btn color="primary" dark class="mb-2" @click="doSelect('', 'curr')">
                Select
                <v-icon right>mdi-check</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { helpListMixin } from '@/mixins/common/helpListMixin'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
export default {
  props: {
    curr: String,
    param: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      headers: [
        { text: 'Currency', value: 'curr' },
        { text: 'Description', value: 'currDesc' }
      ],
      selected: [],
      departments: []
    }
  },
  created() {
    this.doInit()
  },
  computed: {
    menu() {
      return this.$store.state.commons.menu
    }
  },
  watch: {
    menu: function () {
      this.doInit()
    }
  },
  methods: {
    async doInit() {
      this.departments = this.curr.split(',')
      const apiURI = this.menu.commonDataList
      const expand = {
        listName: 'currencies',
        paramString: this.param
      }
      if (apiURI) {
        this.loading = true
        await this.$http
          .get(expandURI(apiURI, expand))
          .then((result) => {
            this.items = []
            this.selectedItems = []
            if (result.data) {
              const { dataList } = result.data
              dataList.map((currList) => {
                const convertList = {
                  key: currList.value,
                  curr: currList.value,
                  currDesc: currList.label
                }
                if (this.checkedItems.includes(currList.value)) {
                  const currencyList = {
                    key: currList.value,
                    curr: currList.value,
                    currDesc: currList.label
                  }
                  this.selectedItems.push(currencyList)
                }
                this.items.push(convertList)
              })
            }
            if (this.checkedItems.toString() === 'All') {
              this.doReset()
              this.toggleAll()
            } else {
              this.toggleSelected()
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    }
  },
  mixins: [TableConst.default, MessageMixin, helpListMixin]
}
</script>
